const e = "https://image.homeexchange.fr/images/website/migration", t = "https://image.homeexchange.fr/images/website/badge";
export {
  e as IMAGE_URL,
  t as IMAGE_URL_BADGE
};
